import React, { useState } from 'react';
import { POSImportForm } from './POSImportForm';
import { POSImportHistory } from './POSImportHistory';
import { AuditLogDashboard } from './AuditLogDashboard';
import { Upload, FileText, ShieldCheck, HelpCircle } from 'lucide-react';

interface Props {
  tenantId: string;
}

export const POSImportDashboard: React.FC<Props> = ({ tenantId }) => {
  const [activeTab, setActiveTab] = useState<'upload' | 'files' | 'audit'>('upload');

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-gray-200/80 pb-5">
        <div>
          <div className="flex items-center gap-2 text-blue-600 mb-1">
            <Upload size={18} className="stroke-[2.5]" />
            <span className="text-xs font-black uppercase tracking-widest">Integration Hub</span>
          </div>
          <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tight">Import POS Tips</h1>
          <p className="text-gray-500 text-sm mt-0.5">
            Upload POS shift batches, configure field bridge mappings, and review import audit history.
          </p>
        </div>

        {/* View Switcher Pills */}
        <div className="flex bg-gray-100 p-1.5 rounded-2xl border border-gray-200 self-start sm:self-auto shrink-0">
          <button
            onClick={() => setActiveTab('upload')}
            className={`flex items-center gap-2 px-4 py-2 text-xs font-bold rounded-xl transition-all ${
              activeTab === 'upload'
                ? 'bg-white shadow-sm text-blue-600'
                : 'text-gray-500 hover:text-gray-800'
            }`}
          >
            <Upload size={15} />
            <span>Upload & Mapper</span>
          </button>
          <button
            onClick={() => setActiveTab('files')}
            className={`flex items-center gap-2 px-4 py-2 text-xs font-bold rounded-xl transition-all ${
              activeTab === 'files'
                ? 'bg-white shadow-sm text-blue-600'
                : 'text-gray-500 hover:text-gray-800'
            }`}
          >
            <FileText size={15} />
            <span>File History</span>
          </button>
          <button
            onClick={() => setActiveTab('audit')}
            className={`flex items-center gap-2 px-4 py-2 text-xs font-bold rounded-xl transition-all ${
              activeTab === 'audit'
                ? 'bg-white shadow-sm text-blue-600'
                : 'text-gray-500 hover:text-gray-800'
            }`}
          >
            <ShieldCheck size={15} />
            <span>Audit Trail</span>
          </button>
        </div>
      </div>

      {/* Tab Panels */}
      <div className="mt-4">
        {activeTab === 'upload' && (
          <POSImportForm tenantId={tenantId} />
        )}

        {activeTab === 'files' && (
          <div className="bg-white rounded-2xl p-6 border border-gray-200/80 shadow-sm">
            <POSImportHistory tenantId={tenantId} />
          </div>
        )}

        {activeTab === 'audit' && (
          <div className="bg-white rounded-2xl p-6 border border-gray-200/80 shadow-sm">
            <AuditLogDashboard tenantId={tenantId} />
          </div>
        )}
      </div>
    </div>
  );
};
